/**
 * this is the footer component
 *
 * Created by Tom on 31/5/17
 */

import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'

// action import
import {ActionCreator} from '../../actions/'

// component import
import AppButton from '../AppButton/'

// style import
import './style.scss'


class Footer extends Component {

    _signOutClick() {
        console.log('Sign Out')
    }

    render() {
        return (
            <div className="footer">

                {/* text container */}
                <div className="footer__text_container">
                    <p className="footer__text">© Copyright Selfmade 2018 Lorem ipsum dolor sit amet per a tutt</p>
                    <a
                        className="footer__links footer__terms"
                        href="https://www.selfmadesuper.com.au/disclaimer"
                        target="_blank">
                        Terms & conditions
                    </a>
                    <a
                        className="footer__links footer__privacy"
                        href="https://www.selfmadesuper.com.au/privacy-policy"
                        target="_blank">
                        Privacy policy
                    </a>
                </div>

                {/* sign out button */}
                <div className="footer__sign-out-button">
                    <AppButton
                        buttonText="SIGN OUT"
                        onClick={::this._signOutClick}
                        size="big"
                        color="blue"/>
                </div>

            </div>
        )
    }
}

// define the prop types
Footer.propTypes = {
    goToRoute: PropTypes.func.isRequired
}

// pull all required action creators into this container
const mapDispatchToProps = (dispatch) => {
    const action = bindActionCreators(ActionCreator, dispatch)
    return {
        goToRoute: action.goToRoute
    }
}

export default connect(null, mapDispatchToProps)(Footer)



// WEBPACK FOOTER //
// ./src/components/Footer/index.js